import React from "react";
import styled from "styled-components/macro";
import respectImg from "../assets/images/1800respect.png";
import djirra from "../assets/images/djirra.png";
import intouch from "../assets/images/intouch.png";
import safesteps from "../assets/images/safesteps.png";
import vals from "../assets/images/vals.png";
import ntv from "../assets/images/ntv.png";
import vla from "../assets/images/vla-logo.png";
import federation from "../assets/images/Fclc_Logo_Sub.png";
import rainbowDoor from "../assets/images/rainbow-door.png";
import orangeDoor from "../assets/images/orange-door.png";
import umalek from "../assets/images/umalek.png";
import dardi from "../assets/images/dardi.png";
import sasv from "../assets/images/sasv.png";
import womensLegal from "../assets/images/womens-legal.png";
import qlaw from "../assets/images/qlaw.png";
import refugeeLegalImg from "../assets/images/refugee legal.png";
import seniorsRightsImg from "../assets/images/seniors-rights-victoria.png";
import villamantaImg from "../assets/images/vdrlc.png";
import youthlawImg from "../assets/images/youth-law-victoria.png";
import { em } from "polished";
import media from "../theme/media";

type ServiceItem = {
  img: string;
  title: string;
  description: string;
  contact: string;
  link: string;
  prettyTitle?: React.ReactNode;
};

const servicesList: Record<string, ServiceItem> = {
  theOrangeDoor: {
    img: orangeDoor,
    title: `The Orange Door`,
    description: `Provides help for people experiencing family violence, or who need assistance with care and wellbeing of children and young people.`,
    contact: `Visit orangedoor.vic.gov.au`,
    link: `https://www.orangedoor.vic.gov.au`,
  },
  victoriaLegalAid: {
    img: vla,
    title: `Victoria Legal Aid`,
    description: `Helping Victorians with their legal problems`,
    contact: `1300 792 387`,
    link: `https://www.legalaid.vic.gov.au/`,
  },
  federationOfCommunityLegalCentres: {
    img: federation,
    title: `Federation of Community Legal Centres`,
    description: `Independent community organisations providing legal services`,
    contact: `(03) 9652 1500`,
    link: `https://www.fclc.org.au/`,
  },
  victoriaAboriginalLegalService: {
    img: vals,
    title: `Victorian Aboriginal Legal Service`,
    description: `Provides legal assistance for community`,
    contact: `1800 064 865`,
    link: `https://www.vals.org.au/`,
  },
  djirraLegal: {
    img: djirra,
    title: `Djirra`,
    description: `Provides culturally safe legal and non-legal supports to Aboriginal and Torres Strait Islander women and children experiencing family violence.`,
    contact: `1800 105 303`,
    link: `https://djirra.org.au/`,
  },
  womensLegalServiceVictoria: {
    img: womensLegal,
    title: `Women's Legal Service Victoria`,
    description: `Support to women experiencing family violence to find safety and get legal advice.`,
    contact: `1800 133 302`,
    link: `https://www.womenslegal.org.au/`,
  },
  qLaw: {
    img: qlaw,
    title: `Q+Law`,
    description: `Provides a free, state-wide, safe entry point for legal assistance for all LGBTIQA+SB Victorians.`,
    contact: `(03) 9968 1002 9am-5pm Monday - Friday`,
    link: `https://qlaw.org.au/`,
  },
  refugeeLegal: {
    img: refugeeLegalImg,
    title: `Refugee Legal`,
    description: `Provides legal assistance to people seeking asylum, refugees and vulnerable migrants`,
    contact: `(03) 9413 0100`,
    link: `https://refugeelegal.org.au/`,
  },
  seniorsRightsVictoria: {
    img: seniorsRightsImg,
    title: `Seniors Rights Victoria`,
    description: `Provides information, legal advice, and casework to older Victorians experiencing or at risk of experiencing elder abuse.`,
    contact: `1300 368 821`,
    link: `https://seniorsrights.org.au/`,
  },
  villamantaDisabilityRightsLegalCentre: {
    img: villamantaImg,
    title: `Villamanta Disability Rights Legal Centre`,
    description: `Legal assistance with a focus on the rights of people with cognitive impairments`,
    contact: `1800 014 111`,
    link: `https://www.villamanta.org.au/`,
  },
  youthlawVictoria: {
    img: youthlawImg,
    title: `Youthlaw Victoria`,
    description: `Provides free, confidential legal assistance to young people aged under 25 in Victoria.`,
    contact: `(03) 9113 9500`,
    link: `https://youthlaw.asn.au/`,
  },
  safeSteps: {
    img: safesteps,
    title: `Safe steps - Family Violence Response Centre`,
    description: `24/7 family violence support service`,
    contact: `1800 015 188`,
    link: `https://www.safesteps.org.au/`,
  },
  noToViolence: {
    img: ntv,
    title: `No to Violence`,
    description: `Working together to end men's family violence`,
    contact: `1300 766 491`,
    link: `https://ntv.org.au/`,
  },
  _1800Respect: {
    img: respectImg,
    title: `1800RESPECT`,
    description: `National domestic, family and sexual violence counselling, information and support service available 24/7 online chat and video call services`,
    contact: `1800 737 732 or Text (0458 737 732)`,
    link: `https://www.1800respect.org.au/`,
  },
  umalekBalitProgram: {
    img: umalek,
    title: `Umalek Balit Program\n(Give Strength, in Woiwurrung)`,
    prettyTitle: <>Umalek Balit Program<br />(Give Strength, in Woiwurrung)</>,
    description: `Culturally safe and relevant program for Aboriginal and Torres Strait Islander families who have family violence related proceedings offers support information and referrals`,
    contact: `umalekbalit.referrals@courts.vic.gov.au`,
    link: `mailto:umalekbalit.referrals@courts.vic.gov.au`,
  },
  djirra: {
    img: djirra,
    title: `Djirra`,
    description: `Provides culturally safe legal and non-legal supports to Aboriginal and Torres Strait Islander women and children experiencing family violence.`,
    contact: `1800 105 303`,
    link: `https://djirra.org.au/`,
  },
  dardiMunwurro: {
    img: dardi,
    title: `Dardi Munwurro`,
    description: `Aboriginal and Torres Strait Islander Family Service`,
    contact: `8456 3044`,
    link: `https://dardimunwurro.com.au/`,
  },
  inTouch: {
    img: intouch,
    title: `inTouch`,
    description: `Multicultural Centre Against Family Violence Specialist service providing tailored support and programs to refugee and migrant women experiencing family violence.`,
    contact: `1800 755 988`,
    link: `https://intouch.org.au/`,
  },
  rainbowDoor: {
    img: rainbowDoor,
    title: `Rainbow Door`,
    description: `A free, peer-run and specialist LGBTIQA+ helpline, providing information, brief support and referral to all LGBTIQA+ Victorians, their friends, families and carers.`,
    contact: `1800 729 367 or text 0480 017 246`,
    link: `https://www.rainbowdoor.org.au/`,
  },
  sexualAssaultServicesVictoria: {
    img: sasv,
    title: `Sexual Assault Services Victoria`,
    description: `Support for victim survivors who may have experienced sexual assault and/or harmful sexual behaviour`,
    contact: `1800 806 292`,
    link: `https://www.sasvic.org.au/`,
  },
};

type Props = {
  services: (keyof typeof servicesList)[];
};

const SupportServices: React.FC<Props> = ({ services }) => {
  return (
    <div>
      {services.map((serviceKey) => {
        const { link, img, title, description, contact, prettyTitle } =
          servicesList[serviceKey];
        return (
          <ServicesBlock href={link} key={link} target="_blank" rel="noopener noreferrer">
            <div className="img-container">
              <img src={img} alt={title} />
            </div>
            <div className="info">
              <p>
                <span className="bold">{prettyTitle || title}</span>
                <br />
                {description}
                <br />
                <span className="bold">{contact}</span>
              </p>
            </div>
          </ServicesBlock>
        );
      })}
    </div>
  );
};

const ServicesBlock = styled.a`
  display: flex;
  text-decoration: none;
  max-width: 600px;
  margin-bottom: ${em(20, 18)};
  align-items: center;
  .img-container {
    max-width: 110px;
    width: 100%;
    img {
      display: block;
      max-width: 100%;
    }
  }

  .bold {
    font-weight: 700;
  }
  .info {
    margin-left: 40px;
    line-height: 1.3;
  }

  ${media.lessThan("tablet")`
    .img-container {
      width: 90px;
    }
    .info {
      margin-left: 20px;
      width: calc(100% - 110px);
    }
    .info p {
      font-size: 16px;
    }
  `}
`;

export default SupportServices;